import urls from "@/constants/urls";
import axios from "axios";
import { reactive } from "vue";

const state = reactive({
  stripePaymentMethods: {},
});

export function useStripePaymentMethods() {
  const stripeElement = usePaymentSystemMetadataApi("stripe-element");

  function setStripePaymentMethods(paymentMethods) {
    state.stripePaymentMethods = paymentMethods;
  }

  function getStripePaymentMethods() {
    if (Object.keys(state.stripePaymentMethods).length === 0) {
      fetchStripePaymentMethods();
    }
    return state.stripePaymentMethods;
  }

  function fetchStripePaymentMethods() {
    return stripeElement.getPaymentSystemMetadata().then((data) => {
      state.stripePaymentMethods = data.data?.payment_method_map || {};
      return state.stripePaymentMethods;
    });
  }

  return {
    state,
    setStripePaymentMethods,
    getStripePaymentMethods,
    fetchStripePaymentMethods,
  };
}

export const usePaymentSystemMetadataApi = (sysname) => {
  async function getPaymentSystemMetadata(params = {}) {
    const url = urls.paymentSystemMetadata(sysname);
    return axios.get(url, { params }).then((r) => r.data);
  }

  return { getPaymentSystemMetadata };
};
